import React, { Component } from 'react';
import ReactQuill from 'react-quill';

import { QuizService } from 'modules/content/quiz';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import './EditorComponent.scss';

class QuizEditorComponent extends Component {
  static propTypes = {
    content: PropTypes.string,
    formats: PropTypes.array,
    modules: PropTypes.array,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    type: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    charLimit: PropTypes.number,
    updateCharCount: PropTypes.func,
    charCount: PropTypes.number,
    index: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      content: props.content
    };
  }

  handleOnChange = (content, delta, source, editor) => {
    const { charLimit, id, parentId } = this.props;

    if (charLimit && editor.getLength() > charLimit + 1 && this.reactQuillRef) {
      UiService.setAlertError(`quiz.answer_limit`, { limit: charLimit });
      const editor2 = this.reactQuillRef.getEditor();
      let delta2 = editor2.getContents();

      delta2 = delta2.slice(0, charLimit);
      editor2.setContents(delta2);
      this.reactQuillRef.focus();
    } else {
      this.setState({ content });
      QuizService.updateQuizContent(id, parentId, content);
    }
    this.props.updateCharCount(charLimit - (editor.getLength() - 1));
  };

  handleOnBlur = () => {
    QuizService.updateQuizContent(
      this.props.id,
      this.props.parentId,
      this.state.content
    );
  };

  componentDidMount() {
    this.checkLength();
  }

  onKeyEnterHandler = () => {
    const value = this.state.content || this.props.content;

    if (!value || QuizService.isProfile()) {
      return;
    }

    const answerStatus = QuizService.checkEmptyAnswers(this.props.parentId);

    if (answerStatus.empty) {
      this.focusNewAnser(answerStatus.index);
    } else {
      const createdAnswer = QuizService.addAnswer(this.props.parentId);

      this.focusNewAnser(createdAnswer);
    }
  };

  focusNewAnser = (id) => {
    setTimeout(() => {
      const answerEl = document.getElementById(id);

      answerEl.querySelector('.ql-editor').focus();
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    }, 500);
  };

  get modules() {
    return (
      this.props.modules || {
        toolbar: [['bold', 'italic', 'underline', 'link']],
        keyboard: {
          bindings: {
            tab: 'disabled',
            enter: {
              key: 13,
              handler: this.onKeyEnterHandler
            }
          }
        }
      }
    );
  }

  get formats() {
    return this.props.formats || ['bold', 'italic', 'underline', 'link'];
  }

  checkLength = () => {
    const { charLimit, charCount } = this.props;

    let initialLenth = 0;

    if (this.reactQuillRef && charLimit && charCount === 0) {
      const editor = this.reactQuillRef.getEditor();

      initialLenth = editor.getLength() - 1;
      this.props.updateCharCount(charLimit - (charCount || initialLenth));
    }
  };

  renderEditor = () => {
    const { className, id, placeholder, readOnly, parentId } = this.props;

    return (
      <ReactQuill
        value={this.state.content || this.props.content}
        theme="bubble"
        formats={this.formats}
        modules={this.modules}
        id={id || ''}
        placeholder={placeholder || ''}
        readOnly={readOnly === true}
        className={`${className} rc-editor-wrapper`}
        onChange={this.handleOnChange}
        onBlur={this.handleOnBlur}
        bounds="#questionsContent"
        name={`${id}-${parentId}`}
        ref={(el) => (this.reactQuillRef = el)}
      />
    );
  };

  render() {
    return this.renderEditor();
  }
}

export default QuizEditorComponent;
